import React, { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Context } from '../../../index';
import { useSocket } from '../../../store/SocketContext';
import {showNotification} from "../../../utils/notifications/notifications";

// helper: текущий чат из URL /chat/:id (подстрой под свой роут если другой)
const getOpenedChatIdFromPath = (pathname) => {
    const m = pathname.match(/\/chat\/(\d+)/);
    return m ? m[1] : null;
};

const GlobalChatNotifications = () => {
    const { user, chat } = useContext(Context);
    const socket = useSocket();
    const location = useLocation();

    // чтобы не спамить одинаковыми уведомлениями
    const lastUnreadRef = useRef(new Map()); // sessionId -> lastUnreadCount

    useEffect(() => {
        if (!socket) return;

        const onChatListUpdate = (data) => {
            const session = data?.session;
            if (!session?.id) return;

            // считаем unreadCount так же, как ты делал в App
            const isOwner = user.isAuth && session.ownerId === user.UserData?.id;
            const unreadCount = isOwner ? (session.ownerUnreadCount || 0) : (session.guestUnreadCount || 0);

            // рост unreadCount = пришло новое входящее
            const prev = lastUnreadRef.current.get(String(session.id)) ?? 0;
            lastUnreadRef.current.set(String(session.id), unreadCount);

            if (unreadCount <= prev) return; // не выросло — не уведомляем

            // если мы прямо сейчас открыли этот чат — не уведомляем
            const openedChatId = getOpenedChatIdFromPath(location.pathname);
            const isSameChatOpened = openedChatId && String(openedChatId) === String(session.id);

            // если вкладка активна и чат открыт — уведомление не нужно
            if (!document.hidden && isSameChatOpened) return;

            // текст уведомления
            const title = "Arento — новое сообщение";
            const body =
                (session.lastMessageContent || `Непрочитанных: ${unreadCount}`).slice(0, 140);

            showNotification({
                title,
                body,
                url: `/chat/${session.id}`, // подстрой под свой роут
            });
        };

        socket.on("chatListUpdate", onChatListUpdate);
        return () => socket.off("chatListUpdate", onChatListUpdate);
    }, [socket, user.isAuth, user.UserData?.id, location.pathname]);

    // полезно синхронизировать prev unread, когда ты грузишь список
    useEffect(() => {
        chat.sessions?.forEach((s) => {
            const c = s.unreadCount || 0;
            lastUnreadRef.current.set(String(s.id), c);
        });
    }, [chat.sessions?.length]);

    return null;
};

export default GlobalChatNotifications;
